module.exports = __webpack_public_path__ + "img/4.fedbd7c5.png";